<template>
<div>
  <div class="main-body">
    <main-header>
      <template #header-right>
        <el-dropdown>
          <div class="user-info" style="cursor: pointer">
            <el-avatar
                :size="32"
                src="https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80"
            ></el-avatar>
            <span class="login-user-name">{{ loginName }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="modifyPassword" >{{ $t('selectPage.update_password') }}</el-dropdown-item>
            <el-dropdown-item @click.native="logout">{{ $t('selectPage.logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </main-header>
    <section class="main-body-section">
      <div class="title" style="height: 42px; overflow: hidden">
        {{ $t('selectPage.center_text') }}
      </div>
      <div class="title-desc">
        <div style="font-size: 12px;height: 16px" v-if="$i18n.locale === 'zh'">I N F O R M A T I O N&nbsp; D I G I T I Z A T I O N&nbsp; M A N A G E M E N T&nbsp; C E N T E R</div>
      </div>

      <div class="desc">{{ $t('selectPage.container_center') }}</div>
      <ul class="system-list">
        <li
            v-for="(system, index) in systemList"
            :key="system.id"
            :class="{ 'enter-animation': isAnimated[index] }"
            @click="toSystemPage(system)">
<!--          为了能右键 展示在新标签打开这个功能-->
          <a @click.prevent.stop="toSystemPage(system)" :href="system.href" v-if="system.href" class="float-a"></a>
          {{ system.companyName }}
<!--          <a href="">{{ system.companyName }}</a>-->
        </li>
      </ul>
    </section>
    <main-footer></main-footer>
  </div>
  <!-- 修改密码 -->
  <el-dialog
      modal-append-to-body
      append-to-body
      destroy-on-close
      :title="$t('selectPage.update_password')" :visible.sync="dialogFormVisible" width="500px" :before-close="() => dialogFormVisible = false">
    <el-form :model="formData" ref="formData" :rules="rules" label-position="top">
      <el-form-item :label="$t('selectPage.old_password')" prop="password">
        <el-input size="small" ref="password" v-model="formData.password" type="password" :placeholder="$t('selectPage.old_password_placeholder')"
                  maxlength="16" autocomplete="on" tabindex="0" prefix-icon="el-icon-lock" show-password>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('selectPage.new_password')" prop="newPassword">
        <el-input size="small" ref="newPassword" v-model="formData.newPassword" type="password" :placeholder="$t('selectPage.new_password_placeholder')"
                  maxlength="16" autocomplete="on" tabindex="1" prefix-icon="el-icon-lock" show-password>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('selectPage.new_password_again')" prop="newCopyPassword">
        <el-input size="small" ref="newCopyPassword" v-model="formData.newCopyPassword" type="password" :placeholder="$t('selectPage.new_password_again_placeholder')"
                  maxlength="16" autocomplete="on" tabindex="1" prefix-icon="el-icon-lock" show-password>
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">
        {{ $t('selectPage.btn_cancel')}}
      </el-button>
      <el-button type="primary" @click="confirmModify('formData')">
        {{ $t('selectPage.btn_confirm')}}
      </el-button>
    </div>
  </el-dialog>
  <SelectWareHouse v-if="selectWareHouseVisible" @close="selectWareHouseVisible=false" :selected-menu="selectedMenu"/>

</div>
</template>

<script>

import MainHeader from "@/components/main-header/index.vue";
import MainFooter from "@/components/main-footer/index.vue";
import {getCookie} from "@/utils/cookie";
import {changeCompany, findBySystemInfo} from "@/api/loginMange";
import {modifyNewPassword, systemRelList, switchLogin} from "@/api/userCenterManage";
import {setEncrypt} from "@/utils/encrypt";
import Cookies from "js-cookie";
import SelectWareHouse from "@/views/system/selectWareHouse.vue";
let reg = /(^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$)/;

export default {
  name: 'SelectPage',
  components: {SelectWareHouse, MainFooter, MainHeader},
  data(){
    return {
      selectWareHouseVisible: false,
      loginName: "",
      dialogFormVisible: false,
      systemList: [],
      rules: {
        password: [
          { required: true, validator: this.validateOldPass, trigger: "blur" },
        ],
        newPassword: [
          { required: true, validator: this.validatePass, trigger: "blur" },
        ],
        newCopyPassword: [
          { required: true, validator: this.validatePass, trigger: "blur" },
        ]
      },

      isAnimated: [], // 控制动态列表项的动画状态
      formData: {
        password: '',
        newPassword: '',
        newCopyPassword: '',
        userName: ''
      },
      selectedMenu: {}
    }
  },
  created() {
    if (this.$route.query && this.$route.query.systemType) {
      this.systemType = this.$route.query.systemType
    }
    this.getAllSystem();
  },
  methods: {
    // 初始化动画并启动
    initAnimation() {
      // 重置动画状态数组，与systemList长度保持一致
      this.isAnimated = new Array(this.systemList.length).fill(false);
      // 启动入场动画
      this.startAllAnimations();
    },

    // 启动所有列表项的动画
    startAllAnimations() {
      this.systemList.forEach((_, index) => {
        // 逐项延迟显示，形成依次入场效果
        setTimeout(() => {
          this.$set(this.isAnimated, index, true);
        }, 50 * index); // 每项间隔50ms
      });
    },
    validateOldPass(rule, value, callback) {
      if (value === "") {
        callback(new Error(this.$t('selectPage.password_placeholder')));
      } else {
        // if (this.forcedEditPasswordShow) {
        //   if (this.formData.checkPass !== "") {
        //     this.$refs.forcePassword.validateField("checkPass");
        //   }
        // } else if (this.forgetPasswordShow) {
        //   if (this.formData.checkPass !== "") {
        //     this.$refs.forgetPassword.validateField("checkPass");
        //   }
        // }

        callback();
      }
    },
    validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error(this.$t('selectPage.password_placeholder')));
      } else if (!reg.test(value)) {
        callback(new Error(this.$t('selectPage.password_format_error')));
      } else {
        // if (this.forcedEditPasswordShow) {
        //   if (this.formData.checkPass !== "") {
        //     this.$refs.forcePassword.validateField("checkPass");
        //   }
        // } else if (this.forgetPasswordShow) {
        //   if (this.formData.checkPass !== "") {
        //     this.$refs.forgetPassword.validateField("checkPass");
        //   }
        // }

        callback();
      }
    },
    // 查询所有系统
    async getAllSystem() {
      let userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
      const userId = userInfo.userId.toString();
      let loginName = '';
      if (userInfo.groupName) {
        loginName = userInfo.groupName  + " - " + userInfo.realName;
      } else {
        loginName = userInfo.realName;
      }
      this.loginName = loginName;
      // 获取系统信息
      let res1 = await findBySystemInfo(userId);
      let res2 = await systemRelList({
        "userId": userInfo.userId2,
      });
      let listData = []
      if (res1.code === "200" && res1.data) {
        listData = listData.concat(res1.data)
      } else {
        // this.$message.error(res1.msg);  这里不需要进行提示
      }
      if (res2.code === "200" && res2.data) {
        res2.data.forEach((item,index)=> {
          item.companyId = item.id
          item.companyName = item.name
          item.checkAuth = true
          item.savePath = item.url
          item.systemType = 'newUserCenter'
        })
        listData = listData.concat(res2.data)
      } else {
        // this.$message.error(res2.msg); 这里不需要进行提示
      }
      for (let i = 0; i < listData.length; i++) {
        listData[i].href = await this.handleFormatData(listData[i])
      }
      this.systemList = listData.filter((item)=>{
        // 国内wims不允许出现rms-us
        if (!window.location?.hostname.includes('wims-us') && item.systemShortName === "RMS-US") {
          return false;
        } else {
          return true;
        }
      })
      console.log(listData)

      this.initAnimation();
    },
    async handleFormatData (item) {
      let href
      const OWMS_ID = "1954416461250306048";
      if (item.id === OWMS_ID) {
        return
      }
      const language = Cookies.get('language') || 'zh'
      if (item.checkAuth) {
        if (item.systemType && item.systemType == 'newUserCenter') {
          // 走新RMS
          href = await this.changeSystemUserCenter(item, language, true)
        } else {
          // 走老的
          href = await this.changeSystem(item.companyId, language, true);
        }
      }
      return href
    },
    // 修改密码
    modifyPassword() {
      this.formData = {
        password: '',
        newPassword: '',
        userName: getCookie("userName")
      }
      this.dialogFormVisible = true
    },
    // 退出登陆
    logout() {

      this.confirmPopBox({
        title: this.$t('selectPage.tip'),
        content: this.$t('selectPage.logout_confirm'),
        callback: () => {

          // this.confirmLayout()
          window.sessionStorage.clear();
          this.$store.commit("userInfo", "");
          if (this.$route && this.$route.query && this.$route.query.systemType) {
            this.$router.push(`/login?systemType=${this.$route.query.systemType}`);
          } else {
            this.$router.push("/login");
          }
          this.$message.success(this.$t('selectPage.logout_success'));
        }
      })
    },
    // 记录用户登录
    async switchUserLogin(id) {
      try {
        const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
        const token = userInfo.token2;
        await switchLogin({ systemId: id, token: token, userId: userInfo.userId2 })
      } catch (error) { }
    },
    // 前往具体系统
    async toSystemPage(item) {
      const OWMS_ID = "1954416461250306048";
      if(item.id === OWMS_ID){
        this.selectWareHouseVisible = true;
        this.selectedMenu = item;
        return
      }
      const language = Cookies.get('language') || 'zh'
      if (item.checkAuth) {
        await this.switchUserLogin(item.id);
        if (item.systemType && item.systemType == 'newUserCenter') {
          // 走新RMS
          this.changeSystemUserCenter(item, language);
        } else {
          // 走老的
          this.changeSystem(item.companyId, language);
        }

      } else {
        this.$message.error(this.$t('selectPage.no_permission_login'));
      }
    },
    async changeSystemUserCenter(data, language, isFormat) {
      if (data.companyName === "权限管理") {
        !isFormat && this.$router.push("/sys/organizational");
        return "#/sys/organizational";
      }
      let userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));

      let loginName = '';
      if (userInfo.groupName) {
        loginName = userInfo.groupName  + " - " + userInfo.realName;
      } else {
        loginName = userInfo.realName;
      }

      // 用户类型
      let businessType = ''
      if (userInfo.itDepartment) {
        if(userInfo.itDepartment.toString() == 'true') {
          businessType = '1'
        } else {
          businessType = '2'
        }
      }

      // 使用userId2, 走新的rms
      const userId = userInfo.userId2;
      const token = userInfo.token2;

      const wimsUserId = userInfo.wimsUserId
      const userName = getCookie('userName')
      const userNameResponse = getCookie('userNameResponse')
      if(['WMS', 'RMS-US'].includes(data.systemShortName)) {
        const loginInfo = JSON.parse(window.sessionStorage.getItem("WMS_LOGIN_INFO"));
        const sysPath = `${data.savePath}${data.systemShortName === 'RMS-US' ? '' : '/#/'}`
        const token = data.systemShortName === 'RMS-US' ? userInfo.token2 : loginInfo.token.accessToken;
        const wmsUserId = data.systemShortName === 'RMS-US' ? wimsUserId : loginInfo.wmsUserId;
        const href = `${sysPath}?token=${token}&username=${loginInfo.username}&realName=${loginInfo.realName}&wmsUserId=${wmsUserId}&companyId=${data.id}&language=${language}`
        !isFormat && window.location.replace(href)
        return href
      }
      if (data.systemShortName == 'finereport' || data.systemShortName == 'fineBI') {
        !isFormat && window.location.replace(
            `${data.savePath}`
        );
        return data.savePath
      } else {
        const href = `${data.savePath}?loginName=` +
            escape(loginName) +
            "&token=" +
            token +
            "&userId=" +
            userId +
            "&companyId=" +
            data.companyId +
            "&companyName=" +
            escape(data.companyName) +
            "&wimsUserId=" +
            wimsUserId +
            "&username=" +
            userName +
            "&businessType=" +
            businessType +
            "&userNameResponse=" +
            userNameResponse +
            "&language=" + language
            console.log(href);
            
        !isFormat && window.location.replace(
            href
        );
        return href
      }
    },
    // 选择系统
    async changeSystem(data, language, isFormat) {
      const res = await changeCompany(data);
      if (res.code === "200") {
        if (res.data.companyName === "权限管理") {
          !isFormat && this.$router.push("/sys/organizational");
          return '#/sys/organizational';
        }
        let userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
        const token = userInfo.token;
        let loginName = '';
        if (userInfo.groupName) {
          loginName = userInfo.groupName  + " - " + userInfo.realName;
        } else {
          loginName = userInfo.realName;
        }
        const userId = userInfo.userId;
        const href = `${res.data.savePath}?loginName=` +
            escape(loginName) +
            "&token=" +
            token +
            "&userId=" +
            userId +
            "&companyId=" +
            res.data.companyId +
            "&companyName=" +
            escape(res.data.companyName) +
            "&language=" + language
        !isFormat && window.location.replace(
            href
        );
        return href
      } else {
        this.$message.warning(res.msg);
      }
    },
    confirmModify(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if(this.formData.password == this.formData.newPassword) {
            this.$message.error(this.$t('selectPage.new_password_same_old_password'))
            return
          }
          if(this.formData.newCopyPassword != this.formData.newPassword) {
            this.$message.error(this.$t('selectPage.new_password_not_same'))
            return
          }
          const res = await modifyNewPassword({
            password: setEncrypt(this.formData.password),
            newPassword: setEncrypt(this.formData.newPassword),
            userName: this.formData.userName
          })
          if(res.code == 200) {
            this.$message.success(this.$t('selectPage.update_password_success'))
            this.dialogFormVisible = false
          } else {
            this.$message.error(res.msg)
          }
        } else {
          return false;
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .el-dialog__header {
    border-bottom: 1px solid rgb(231,231,231);
    padding: 15px 24px;
    >.el-dialog__title{
      font-weight: 600;
      font-size: 16px;
    }
  }
  .el-dialog__body{
    padding: 16px 24px;
  }
  .el-dialog__footer{
    border-top: 1px solid rgb(231,231,231);
    padding: 12px 24px;
    .el-button{
      font-size: 13px;
      padding: 8px 20px;
    }
  }
  .el-form--label-top{
    .el-form-item__label {
      color: #000000;
      padding: 4px 0;
      line-height: 14px;
      font-size: 12px;
      width: max-content;
    }
  }
}
.main-body{
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: #0d213c;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-image: url("/home-bg.jpg");
  /* 浏览器支持 WebP 格式时，使用 WebP 图 */
  @supports (background-image: url("data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA")) {
    background-image: url("/home-bg.webp");
  }

  &-section {
    padding-top: 50px;
    width: 100%;
    height: calc(100% - 120px);
    grid-template-rows: max-content max-content max-content auto;
    display: grid;
    place-items: center;
  }
}

.user-info {
  display: grid;
  grid-template-columns: 32px max-content max-content;
  justify-items: start;
  align-items: center;
  color: #ffffff;
  gap: 16px;
}

.title{
  color: #ffffff;
  width: 880px;
  font-size: 32px;
  font-weight: 600;
  text-align: justify;

}
.title-desc{
  width: 880px;
  height: 60px;
}
.title-desc > div{
  color: #ffffff;
  width: 880px;
  font-size: 32px;
  font-weight: 600;
  text-align: justify;
}
/* 解决最后一行不生效的问题 */
.title::after, .title-desc > div::after {
  content: "";
  display: inline-block;
  width: 100%; /* 强制最后一行也均匀分布 */
}

.desc{
  color: #ffffff;
  width: 880px;
  height: auto;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  white-space: pre;
  line-height: 1.5;
}
.system-list{
  width: max-content;
  margin: 0 auto;
  padding: 2px;
  max-height: 290px;
  overflow-y: auto;
  display: grid;
  grid-template-columns: 230px 230px 230px 230px;
  color: #ffffff;
  overflow-x: hidden;
  gap: 12px 24px;
  > li {
    cursor: pointer;
    overflow: hidden;
    position: relative;
    padding: 8px;
    display: flex;
    width: 230px;
    height: 60px;
    text-align: center;
    font-size: 18px;
    font-weight: 400;
    vertical-align: center;
    background-color: rgba(255, 174, 114 ,0.05);
    align-items: center; /* 垂直居中 */
    /* 可选：水平居中 */
    justify-content: center;
    transition: all 0.3s ease;
    /* 初始动画状态 */
    opacity: 0;
    transform: translateY(10px);
  }
  > li::before {
    left: 0;
    top: 0;
    position: absolute;
    width: 100%;
    content: "";
    display: inline-block;
    height: 100%;
    background-image: url("/system.png");
    background-size: 100% 100%;
  }
  > li.enter-animation {
    opacity: 1;
    transform: translateY(0);
  }
  > li:hover {
    color:rgba(255, 174, 114 , 1);
    background-color: rgba(255, 174, 114 ,0.2);
    transform: translateY(-2px) scale(1.02); /* 上浮5px并轻微放大 */
    //box-shadow: 0 8px 16px rgba(255, 174, 114, 0.3); /* 增强阴影 */
  }

}

.system-list::-webkit-scrollbar {
  width: 6px;
}
.system-list::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: rgba(255, 174, 114 ,0.2);
}
.float-a{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
</style>
